import React from 'react';
import {LauncherComponentBase} from '../../base-components/launcher-component-base';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import {observer} from 'mobx-react';
import {Check} from '@sparkware/app-utils';
import {INPUT_MIN_PADDING, INPUT_MIN_WIDTH} from '../../../launcher-style-consts';

export interface BooleanValueEditorComponentProps {
    configurationKey: string;
    title?: string;
    description?: string;
}


const CHECK_VALUES = {
    DEFAULT_VALUE:'Default',
    YES:'Yes',
    NO:'No',
};

@observer
export class BooleanValueEditorComponent extends LauncherComponentBase<BooleanValueEditorComponentProps> {

    private _onChangeHandler = (event) => {
        switch(event.target.value) {
            case CHECK_VALUES.YES:
                this.services.configsStorage.updateValue(this.props.configurationKey, true);
                break;
            case CHECK_VALUES.NO:
                this.services.configsStorage.updateValue(this.props.configurationKey, false);
                break;
            default:
                this.services.configsStorage.resetToDefault(this.props.configurationKey);
        }

    };

    private _fromBoolToValue() {
        let currentValue = this.services.configsStorage.getValue(this.props.configurationKey);
        if(Check.isNullOrUndefined(currentValue)) {
            return CHECK_VALUES.DEFAULT_VALUE
        } else if (currentValue === true) {
            return CHECK_VALUES.YES;
        } else {
            return CHECK_VALUES.NO;
        }
    }


    render() {
        let labelId = `${this.props.configurationKey}-label`;
        return (
            <div style={{padding: INPUT_MIN_PADDING}}>
                <FormControl style={{minWidth: INPUT_MIN_WIDTH}}>
                    <InputLabel id={labelId}>
                        {this.props.title}
                    </InputLabel>
                    <Select value={this._fromBoolToValue()} onChange={this._onChangeHandler} labelId={labelId}>
                        <MenuItem key={CHECK_VALUES.DEFAULT_VALUE} value={CHECK_VALUES.DEFAULT_VALUE}>{CHECK_VALUES.DEFAULT_VALUE}</MenuItem>
                        <MenuItem key={CHECK_VALUES.YES} value={CHECK_VALUES.YES}>{CHECK_VALUES.YES}</MenuItem>
                        <MenuItem key={CHECK_VALUES.NO} value={CHECK_VALUES.NO}>{CHECK_VALUES.NO}</MenuItem>
                    </Select>

                </FormControl>
            </div>
        )
    }
}